import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from './RemoveUserConfirmationModal.module.scss';

interface RemoveUserConfirmationModalProps {
  modalOpen: boolean;
  okMethod: () => void;
  cancelMethod: () => void;
  userName: string | undefined;
}

const RemoveUserConfirmationModal: React.FunctionComponent<RemoveUserConfirmationModalProps> = ({
  modalOpen,
  cancelMethod,
  okMethod,
  userName,
}) => {
  const intl = useIntl();

  return (
    <Dialog
      aria-labelledby="remove-wir-user-dialog"
      open={modalOpen}
      maxWidth="md"
      scroll="body"
      classes={{ paperWidthMd: styles.paperWidthMd, root: styles.root }}
      data-testid="remove-wir-user-dialog"
    >
      <MuiDialogTitle classes={{ root: styles.titleDialog }}>
        <Typography variant="h6">
          {intl.formatMessage({
            id: 'wellGuardian.wir.userRoleSettings.removeUserTitle',
          })}
        </Typography>
      </MuiDialogTitle>
      <MuiDialogContent classes={{ root: styles.contentRoot }}>
        <div className={styles.modalText}>
          {intl.formatMessage(
            {
              id: 'wellGuardian.wir.userRoleSettings.removeUserContent',
            },
            { name: userName },
          )}
        </div>
      </MuiDialogContent>
      <MuiDialogActions classes={{ root: styles.actionButtons }}>
        <Button onClick={cancelMethod} className={styles.cancelButton}>
          {intl.formatMessage({
            id: 'wellGuardian.wir.createNewWIRModal.cancel',
          })}
        </Button>
        <Button onClick={okMethod} className={styles.okButton}>
          {intl.formatMessage({
            id: 'wellGuardian.wir.userRoleSettings.remove',
          })}
        </Button>
      </MuiDialogActions>
    </Dialog>
  );
};

export default RemoveUserConfirmationModal;
